import React from "react";

import { Col } from "react-bootstrap";


import "./index.scss";


type HeaderComponentProps = {
    type: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
    text: string;
    cssClasses?: string[];
    xs?: number; sm?: number; lg?: number; xl?: number;
};


export const HeaderComponent:React.FC<HeaderComponentProps> = ({
    type, text, cssClasses = [],
    xs, sm, lg, xl
}) => {

    const classes = ['header-component', ...cssClasses].join(' ');

    return (
        <Col as={type} xs={xs} sm={sm} lg={lg} xl={xl} className={classes}>
            <span>{text}</span>
        </Col>
    );

};


export default HeaderComponent;
